import { render, staticRenderFns } from "./VSelectSearchProductGroup.vue?vue&type=template&id=4027a49e&scoped=true&"
import script from "./VSelectSearchProductGroup.vue?vue&type=script&lang=js&"
export * from "./VSelectSearchProductGroup.vue?vue&type=script&lang=js&"
import style0 from "./VSelectSearchProductGroup.vue?vue&type=style&index=0&id=4027a49e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027a49e",
  null
  
)

export default component.exports